export { default } from "./HonorSystem";